import { render, staticRenderFns } from "./detailIngameTmarker.vue?vue&type=template&id=33eb916b&scoped=true"
import script from "./detailIngameTmarker.vue?vue&type=script&lang=js"
export * from "./detailIngameTmarker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33eb916b",
  null
  
)

export default component.exports